// class ClassPrinter {
//   constructor() {
//     this.lines = [];
//     this.myFont = "24pt Times New Roman";
//     this.pageHeight = 600; // Change to your desired page height
//   }

//   print(text) {
//     const linesArray = text.split("\n");
//     this.lines.push(...linesArray);
//     this.printPage();
//   }

//   printPage() {
//     const printWindow = window.open("2px", "2px", "width=600,height=600");
//     printWindow.document.open();
//     printWindow.document.write(
//       "<html><head><title>Farmer Records Reciept</title></head><body>"
//     );
//     printWindow.document.write(
//       '<pre style="font-family: Times New Roman; font-size: 12pt;">'
//     );
//     let remainingHeight = this.pageHeight;

//     while (this.lines.length > 0) {
//       const line = this.lines.shift();
//       const lineHeight = this.measureTextHeight(line);

//       if (lineHeight <= remainingHeight) {
//         printWindow.document.write(`${line}<br>`);
//         remainingHeight -= lineHeight;
//       } else {
//         this.lines.unshift(line); // Put the line back in the queue
//         break;
//       }
//     }

//     printWindow.document.write("</pre></body></html>");
//     printWindow.document.close();
//     printWindow.print();
//     printWindow.close();
//   }

//   measureTextHeight(text) {
//     const tempElement = document.createElement("divcontents");
//     tempElement.style.font = this.myFont;
//     tempElement.style.display = "inline";
//     tempElement.style.position = "absolute";
//     tempElement.style.visibility = "hidden";
//     tempElement.innerHTML = text;
//     document.body.appendChild(tempElement);
//     const height = tempElement.offsetHeight;
//     document.body.removeChild(tempElement);
//     return height;
//   }
// }
// export default ClassPrinter;


// AI print
class ClassPrinter {
  constructor() {
    this.lines = [];
    this.myFont = "12pt Courier New"; // Monospace font
    this.pageHeight = 600; // Can be tuned or removed for continuous roll printing
  }

  print(text) {
    const linesArray = text.split("\n");
    this.lines.push(...linesArray);
    this.printPage();
  }

  printPage() {
    const printWindow = window.open("", "PRINT", "width=300,height=600");

    printWindow.document.open();
    printWindow.document.write(`
      <html>
      <head>
        <title>Receipt</title>
        <style>
          body {
            margin: 0;
            padding: 5px;
            font-family: 'Courier New', monospace;
            font-size: 12pt;
            width: 250px; /* ~58mm paper */
            white-space: pre;
          }
        </style>
      </head>
      <body>
    `);

    let remainingHeight = this.pageHeight;

    while (this.lines.length > 0) {
      const line = this.lines.shift();
      const lineHeight = this.measureTextHeight(line);

      if (lineHeight <= remainingHeight) {
        printWindow.document.write(`${line}\n`);
        remainingHeight -= lineHeight;
      } else {
        this.lines.unshift(line);
        break;
      }
    }

    printWindow.document.write("</body></html>");
    printWindow.document.close();

    // Wait to print for layout to fully load
    printWindow.focus();
    printWindow.onload = () => {
      printWindow.print();
      printWindow.close();
    };
  }

  measureTextHeight(text) {
    const tempElement = document.createElement("div");
    tempElement.style.font = this.myFont;
    tempElement.style.position = "absolute";
    tempElement.style.visibility = "hidden";
    tempElement.style.whiteSpace = "pre";
    tempElement.innerText = text;
    document.body.appendChild(tempElement);
    const height = tempElement.offsetHeight;
    document.body.removeChild(tempElement);
    return height;
  }
}

export default ClassPrinter;
